import axios from "axios";
import { useTranslation } from "react-i18next";
import { useIsEdgeLocal, useReservationsLocked } from "../../../hooks/useEdgeMode";
import { useAppSelector } from "../../../store/hooks";
import { formatClock } from "../logic/dayTime";

/**
 * „Резервации" срещу касата (docs/edge.md §Резервации без интернет):
 *  • `locked` — локален режим с каса, която НЕ умее резервации: страницата
 *    показва „Недостъпно без интернет", както досега;
 *  • `dataAsOf` — локален режим с каса, която ги умее: „данни към 14:32"
 *    (кога касата е получила изгледа за последно) — `detail` на
 *    `CloudLinkBanner`, не отделен ред на страницата.
 */
export const useReservationsEdge = () => {
  const { t } = useTranslation();
  const isEdgeLocal = useIsEdgeLocal();
  const locked = useReservationsLocked();
  const asOf = useAppSelector((state) => state.edge.reservationsAsOf);
  const asOfMs = asOf ? Date.parse(asOf) : Number.NaN;
  const dataAsOf =
    isEdgeLocal && !locked && Number.isFinite(asOfMs)
      ? t("reservations.dataAsOf", { time: formatClock(asOfMs) })
      : null;
  return { isEdgeLocal, locked, dataAsOf };
};

/**
 * 503 от касата: изгледът ѝ е стар (прекъсването е дошло след дълго без
 * опресняване) или денят е извън прозореца, който тя пази. Страницата
 * показва „Недостъпно без интернет", а не „Грешка".
 */
export const isTillUnavailable = (error: unknown): boolean =>
  axios.isAxiosError(error) && error.response?.status === 503;
